<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
    <div class="flex-s-c">
      <span class="key">服务日期：</span>
      <span class="value">{{currentContent.serviceDate}}（星期{{weekDay}}）</span>
    </div>
    <div class="flex-s-fs mat10">
      <span class="key">服务时间：</span>
      <span class="value">
        <el-checkbox-group v-model="checkList" v-if="edit">
          <el-checkbox :label="currentContent.serviceInfoList.taskId" v-if="currentContent.serviceInfoList&&currentContent.serviceInfoList.flag==1"><span>上午：09:00~12:00</span></el-checkbox>
          <el-checkbox :label="currentContent.serviceInfoList.taskId" v-if="currentContent.serviceInfoList&&currentContent.serviceInfoList.flag==2"><span>下午：12:00-16:15</span></el-checkbox>
        </el-checkbox-group>
        <template v-else>
          <div style="margin-top:6px" v-if="currentContent.serviceInfoList&&currentContent.serviceInfoList.flag==1">
            <div>上午：09:00~12:00</div>
            <div>{{currentContent.serviceInfoList.volunteerName}}</div>
          </div>
          <div style="margin-top:10px" v-if="currentContent.serviceInfoList&&currentContent.serviceInfoList.flag==2">
            <div>下午：12:00-16:15</div>
            <div>{{currentContent.serviceInfoList.volunteerName}}</div>
          </div>
        </template>
      </span>
    </div>
    <div v-if="edit">{{currentContent.serviceInfoList?currentContent.serviceInfoList.volunteerName:""}}</div>
    <!-- <div class="flex-s-c mat10" v-if="edit">
      <span class="key">就餐申请：</span>
      <span class="value">
        <el-switch v-model="eat" active-color="#007083" inactive-color="#A5ACBE">
        </el-switch>
      </span>
    </div> -->
    <span slot="footer" class="dialog-footer" v-if="edit">
      <el-button type="primary" @click="submitDialog" size="small">确 定</el-button>
      <el-button @click="closeDialog" size="small" plain>取 消</el-button>
    </span>
    <span slot="footer" class="dialog-footer" v-else>
      <el-button type="primary" @click="closeDialog" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formatDate } from '@/libs/utils'
export default {
  components: {},
  props: {
    dialogVisible: {
      //弹窗组件是否显示 默认不显示
      type: Boolean,
      default: false,
      required: true,
    },
    title: {
      //弹窗标题
      type: String,
      default: '标题',
      required: true,
    },
    edit: {
      //是否编辑
      type: Boolean,
      default: false,
      required: true,
    },
    currentContent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      checkList: [],
      eat: false,
      weekDay: ""
    };
  },
  computed: {},
  watch: {
    currentContent() {
      // console.log(this.currentContent)
      this.weekDay = formatDate(this.currentContent.serviceDate, 4)
    }
  },
  methods: {
    handleClose(done) {
      this.checkList = []
      this.$emit("on-close");
    },
    submitDialog() {
      if (this.checkList.length == 0) {
        this.$message.error("请选择服务时间");
      } else {
        let params = {
          checkList: this.checkList,
          date: this.currentContent.explainDate
        }
        this.checkList = []
        this.$emit("on-submit", 'service', params);
        this.$emit("on-close");
      }
    },
    closeDialog() {
      this.checkList = []
      this.$emit("on-close");
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "./modal.less";
</style>
